module.exports = __webpack_public_path__ + "static/media/roban.2fdb6fa4.png";